import { render } from "./AddHabitantModal.vue?vue&type=template&id=ec15ad60"
import script from "./AddHabitantModal.vue?vue&type=script&lang=js"
export * from "./AddHabitantModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__